import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {BackendService} from './core/services/backend.service';
import {LocalStorageService} from 'ngx-webstorage';
import {AppLocalStateService} from "./core/services/app-local-state.service";
import {TranslateService} from "@ngx-translate/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {preferred_lang} from "./core/signals/translation.signal";
import { CookieService } from './core/services/cookie.service';
import { LanguageService } from './core/services/language.service';
import { NgxTolgeeModule } from '@tolgee/ngx';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgxTolgeeModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    title = 'FYES';

    @ViewChild("main") main: ElementRef | undefined;

    constructor(
        private backendService: BackendService,
        private localStorageService: LocalStorageService,
        private translate: TranslateService,
        public appLocal: AppLocalStateService,
        private cookieService: CookieService,
        private languageService: LanguageService,
    ) {
        // this.translate.addLangs(['en', 'el']);
        // this.translate.setDefaultLang('el');
        // this.translate.use(this.localStorageService.retrieve("preferred_lang") || 'el');
        // preferred_lang.set(this.cookieService.getCookie('preferred_lang') || 'en');
        // The signal defaults to 'en' — the persisted choice is the real answer.
        // Seed both it and the cookie the interceptor reads, otherwise a reload
        // renders Greek from localStorage while every request asks for `lang=en`.
        const lang = this.languageService.current;
        preferred_lang.set(lang);
        this.cookieService.setCookie('preferred_lang', lang, 365);

        // Add relevant user data to sentry for logging whenever they are updated
        this.appLocal.setupSentryUser();
        this.localStorageService.observe('installationId')
            .pipe(takeUntilDestroyed())
            .subscribe(() => this.appLocal.setupSentryUser());
        this.localStorageService.observe('uid')
            .pipe(takeUntilDestroyed())
            .subscribe(() => this.appLocal.setupSentryUser());
        this.localStorageService.observe('session_token')
            .pipe(takeUntilDestroyed())
            .subscribe(() => this.appLocal.setupSentryUser());

        this.localStorageService.observe("preferred_lang")
            .pipe(takeUntilDestroyed())
            .subscribe((lang: string) => {
                if (lang && this.translate.getLangs().includes(lang)) {
                    this.translate.use(lang);
                    // Workaround for date pipes since LOCALE_ID is not updated dynamically
                    preferred_lang.set(lang);
                }
            });
    }

    ngOnInit() {
        if (!this.localStorageService.retrieve('installationId')) {
            this.backendService.getInstallation().subscribe((response) => {
                if (response.installationId) {
                    this.localStorageService.store('installationId', response.installationId);
                }
            });
        }
    }
}
